import React, { FC, PropsWithChildren, useEffect } from 'react';

import { UI } from '../../../../constants';
import { useUserAction } from '../../../common/hooks/useUserAction';
import { cleanDeferredAction, getDeferredAction } from '../../../util/deferredAction';

export const DeferredActionEmitter: FC<PropsWithChildren<{}>> = ({ children }) => {
  const emit = useUserAction(UI.NAVIGATED);
  useEffect(() => {
    if (getDeferredAction()) {
      cleanDeferredAction();
      emit({});
    }
  }, []);

  return <>{children}</>;
};
